/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Teaser_DescInputs */

const en_vc_onl_teaser_desc = /** @type {(inputs: Vc_Onl_Teaser_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The full app runs in your browser through WebAssembly. Open it, draw, and save your work to your computer. No account, no upload.`)
};

const zh_vc_onl_teaser_desc = /** @type {(inputs: Vc_Onl_Teaser_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整版应用通过 WebAssembly 在浏览器中运行。打开就能画，作品保存到你自己的电脑上。无需账号，不会上传。`)
};

/**
* | output |
* | --- |
* | "The full app runs in your browser through WebAssembly. Open it, draw, and save your work to your computer. No account, no upload." |
*
* @param {Vc_Onl_Teaser_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_teaser_desc = /** @type {((inputs?: Vc_Onl_Teaser_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Teaser_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_teaser_desc(inputs)
	return zh_vc_onl_teaser_desc(inputs)
});
export { vc_onl_teaser_desc as "vc.onl.teaser.desc" }